module.exports = __webpack_public_path__ + "img/effects-8.3ae43514.png";